import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ERROR_DIALOG_PORT } from 'app/core/errors/error.tokens';
import { ErrorDialogAdapter } from './error-dialog.adapter';

/**
 * Provider, der den UI-Adapter für Fehlerdialoge registriert.
 */
export function provideErrorDialogUi(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: ERROR_DIALOG_PORT, useClass: ErrorDialogAdapter },
    ]);
}
